import React, { Fragment, useState } from "react";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import AxiosConfig from "axiosConfig";
import "containers/Projects/Details/ProjectDetails.css";
import Button from "react-bootstrap/Button";
import "../../../../node_modules/video-react/dist/video-react.css";
import cookie from "react-cookies";
import "containers/ProjectCommon.css";
import ProjectBanner from "components/Project/ProjectBanner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import TextTheme from "../../../components/General/Text/TextTheme";
import ProgressStepper from "../../../components/Project/ProgressStepper";
import CustomDatepicker from "components/General/Form/CustomDatepicker";
import { FaCheck } from "react-icons/fa";
import UpdatePassword from "../../../components/Account/Profile/UpdatePassword";

class ProjectDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectMission: "",
      projectGoal: "",
      projectVideoName: "",
      projectVideo: "",
      projectBanner: "",
      projectName: "",
      userEmail: cookie.load("user_email"),
      projectPinterest: "",
      projectFiles: "",
      projectFileNames: "",
      openReferences: false,
      errorMessage: "",
      challengeName: this.props.location.state.challengeSlug,
      goalDate: this.props.location.state.goalDate || "",
      challengeInfo: new Map(),
      adventureId: this.props.location.state.adventureId,
      adventureSlug: this.props.location.state.adventureSlug,
      showModal: false,
      challengeSlugName: "",
    };
  }
  componentDidMount() {
    const projectSlug = this.props.match.params.slug;
    AxiosConfig.get(`/impactprojects/project/${projectSlug}/`)
      .then((res) => {
        this.setState({
          projectMission: res.data.mission,
          projectName: res.data.name,
          projectExploration: res.data.exploration,
          projectReferences: res.data.references,
          projectBanner: res.data.banner,
          projectGoal: res.data.goal,
          projectVideoName: res.data.project_video_name,
          projectVideo: res.data.video,
          projectPinterest: res.data.pinterest,
          projectFiles: res.data.uploads,
          projectFileNames: res.data.uploads.map(function (value) {
            return value.name;
          }),
          projectFileUrls: res.data.uploads.map(function (value) {
            return value.upload;
          }),
        });
      })
      .catch();

    AxiosConfig.get(`/impactprojects/project/challenges/${projectSlug}`)
      .then((res) => {
        var response_data = res["data"];
        var i;
        var challengeList = [];
        let challengeInfo = new Map();
        for (i = 0; i < response_data.length; i++) {
          challengeList[i] = response_data[i];
          challengeInfo.set(
            response_data[i]["slug"],
            response_data[i]["adventure"]
          );
        }
        this.setState({
          challengeList: challengeList,
          challengeInfo: challengeInfo,
        });
      })
      .catch();
  }
  onSubmit() {
    const projectSlug = this.props.match.params.slug;

    let nextUrl = "";
    if (this.state.adventureSlug == "SPREAD_THE_WORD") {
      nextUrl = "/projects/" + projectSlug + "/spread-the-word";
    } else if (this.state.adventureSlug == "LEARN_NEW_SKILL") {
      nextUrl = "/projects/" + projectSlug + "/learn-new-skill";
    } else if (this.state.adventureSlug == "DEVELOP_NEW_HABIT") {
      nextUrl = "/projects/" + projectSlug + "/develop-new-habit";
    } else if (this.state.adventureSlug == "VOLUNTEER") {
      nextUrl = "/projects/" + projectSlug + "/volunteer-time";
    } else if (this.state.adventureSlug == "GIVE_A_DONATION") {
      nextUrl = "/projects/" + projectSlug + "/give-a-donation";
    } else if (this.state.adventureSlug == "RAISE_FUNDS") {
      nextUrl = "/projects/" + projectSlug + "/fundraise";
    } else if (this.state.adventureSlug == "RAISE_YOUR_VOICE") {
      nextUrl = "/projects/" + projectSlug + "/raise-your-voice";
    }

    if (
      this.state.challengeName == "" ||
      this.state.goalDate == "" ||
      this.state.challengeName == undefined ||
      this.state.goalDate == undefined
    ) {
      this.setState({
        errorMessage: "Please select a challenge and a target date",
      });
    } else {
      this.setState({ errorMessage: "" });
      let form_data = new FormData();
      form_data.append("project", projectSlug);
      form_data.append("challenge", this.state.challengeName);
      form_data.append("goal_date", this.formatDate(this.state.goalDate));
      form_data.append(
        "projectUserId",
        this.props.location.state.projectUserId
      );
      if (this.props.location.state.isInvite) {
        form_data.append("create_type", "invite");
        form_data.append("inviter_user_email", this.props.location.state.email);
        form_data.append(
          "invitationId",
          this.props.location.state.invitationId
        );
      }
      AxiosConfig.post("/impactprojects/start_new/", form_data)
        .then((res) => {
          let projectUserId = undefined;
          if (res.data.project_user_id == undefined) {
            projectUserId = this.props.location.state.projectUserId;
          } else {
            projectUserId = res.data.project_user_id;
          }
          this.props.location.state.isInvite
            ? this.props.history.push({
              pathname: nextUrl,
              state: {
                challengeSlug: this.state.challengeName,
                goalDate: this.state.goalDate,
                adventureId: this.state.adventureId,
                adventureSlug: this.state.adventureSlug,
                projectSlug: projectSlug,
                isInvite: this.props.location.state.isInvite,
                email: this.props.location.state.email,
                invitationId: this.props.location.state.invitationId,
                projectUserId: projectUserId,
              },
            })
            : this.props.history.push({
              pathname: `/projects/${projectSlug}/start-project-step-one`,
              state: {
                challengeSlug: this.state.challengeName,
                goalDate: this.state.goalDate,
                adventureId: this.state.adventureId,
                adventureSlug: this.state.adventureSlug,
                projectUserId: projectUserId,
              },
            });
        })
        .catch();
    }
  }
  startProject_new = (challengeSlug) => {
    const project = this.props.match.params.slug;
    let adventure = this.state.challengeInfo.get(challengeSlug);
    this.setState({
      challengeName: challengeSlug,
      adventureId: adventure.id,
      adventureSlug: adventure.slug,
      showModal: false,
    });
    var elems = document.getElementsByClassName("ChallengesDescription");
    [].forEach.call(elems, function (el) {
      el.classList.remove("active");
    });
    document.getElementById(challengeSlug).classList.add("active");
  };
  confirmChallengeChange = (challengeSlug) => {
    this.setState({
      showModal: true,
      challengeSlugName: challengeSlug,
    });
  };
  closeModal() {
    this.setState({
      showModal: !this.state.showModal,
    });
  }
  returnAttatchment = (x) => {
    return (
      <div className="rowattachment">
        <FontAwesomeIcon
          rotation={90}
          icon={faPaperclip}
          color="#1A3867"
          style={{ marginRight: "10px" }}
        />
        <a
          href={x.upload}
          target="_blank"
          rel="noreferrer"
          style={{ color: "#1A3867" }}
          download
        >
          {x.name}
        </a>
      </div>
    );
  };
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  handleDateChange = (event) => {
    this.setState({ goalDate: event.target.value });
  };

  render() {
    return (
      <Fragment>
        <div className="header_main">
          <link
            href="//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.css"
            rel="stylesheet"
          ></link>
          <div className="page_main">
            <div className="page_info_vr_content_main">
              <ProjectOldInfo
                vertical={true}
                project={this.props.match.params.slug}
              />
            </div>
            <div className="page_details_main">
              <div className="project-banner">
                <ProjectBanner image={this.state.projectBanner} />
              </div>
              <div className="page_info_hr_content_main">
                <ProjectOldInfo
                  project={this.props.match.params.slug}
                  showChallengeDetails={
                    this.props.location.state.challengeSlug !== undefined
                      ? true
                      : false
                  }
                />
              </div>
              <div className="page_details_content_main border-0">
                <div className="stepper_main_content">
                  <ProgressStepper
                    currentStep="0"
                    isInvite={this.props.location.state.isInvite}
                    showStepper={true}
                  />
                </div>
              </div>
              <div className="page_details_content_main">
                <div className="mb-15 d-inline-block w-100 project-details">
                  <div className="insideContent">
                    <h3 className="textHeader">STEP 1 : CREATE A CHALLENGE</h3>
                    <p className="insideContent">
                      1. Set a project goal that you can work towards in making
                      a difference in the world.
                    </p>
                  </div>
                  <div trigger="Challenges">
                    {this.state.challengeList &&
                      this.state.challengeList.map((element, index) => (
                        <div
                          onClick={() =>
                            this.props.location.state.isInvite
                              ? this.startProject_new(element["slug"])
                              : this.props.location.state.challengeSlug !==
                                undefined
                                ? this.confirmChallengeChange(element["slug"])
                                : this.startProject_new(element["slug"])
                          }
                          className={
                            this.state.challengeName === element.slug
                              ? "ChallengesDescription active"
                              : "ChallengesDescription"
                          }
                          id={element.slug}
                        >
                          <span className="check">
                            <FaCheck size={18} style={{ fill: "#ff431b" }} />
                          </span>
                          <section
                            className="left-section"
                            style={{ backgroundImage: `url(${element.image})` }}
                          ></section>
                          <section className="right-section">
                            <h3 className="textHeader">{element["name"]}</h3>
                            <div
                              className="insideContent"
                              dangerouslySetInnerHTML={{
                                __html: element["desc"].substring(0, 550),

                              }}
                            ></div>
                          </section>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="project-details mt-15">
                  <div className="mt-15 insideContent">
                    2. Set a target date to complete your goal:
                  </div>
                  <div className="Datepicker">
                    <CustomDatepicker
                      value={this.state.goalDate}
                      handleChange={this.handleDateChange.bind(this)}
                      placeholder="MM/DD/YYYY"
                      minDate={new Date()}
                    />
                  </div>
                </div>
                <div className="project-details">
                  <TextTheme
                    message={this.state.errorMessage}
                    className="text_small text_red text-center"
                  />
                </div>
                <div className="project-details">
                  <Button
                    onClick={this.onSubmit.bind(this)}
                    className="startButton"
                    size="lg"
                  >
                    Next
                  </Button>
                </div>
              </div>
              {this.state.projectPinterest ? (
                <div className="page_details_content_main mt-15 d-flex justify-space-between align-items-baseline">
                  <a
                    href={this.state.projectPinterest}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="textHeader"
                  >
                    Explore More
                  </a>
                  <a href={this.state.projectPinterest} target="_blank">
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      color="#1A3867"
                      style={{ marginRight: "10px", float: "right" }}
                    />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="change-challenge-modal">
          <UpdatePassword
            showModal={this.state.showModal}
            closeModal={this.closeModal.bind(this)}
            challengeSlugName={this.state.challengeSlugName}
            startProject_new={this.startProject_new.bind(this)}
            changeChallenge={true}
          />
        </div>
      </Fragment>
    );
  }
}
export default ProjectDetails;
